import { api } from "jiffy-api";
import initFollowSignIn from "components/jiffy/brands/follow-brand-store-sign-in/follow-brand-store-sign-in";
import "./brand-follow.scss";
import { notifyError } from "common/utils/app-monitoring/notify";

const $getFollowButton = () => document.getElementById("brand-page-follow-button");
const $getFollowLabel = () => document.getElementById("brand-page-follow-label");
const $$signInModal = () => $(".js-follow-brand-store-sign-in");

const initFollow = () => {
  const $followButton = $getFollowButton();
  if (!$followButton) return;

  const $followLabel = $getFollowLabel();
  const followClass = "brand-page__follow-button--follow";
  const unFollowClass = "brand-page__follow-button--unfollow";

  const followHandler = async () => {
    if ($followButton.dataset?.signedIn === "false") {
      $$signInModal().modal("show");
      return;
    }

    const action = $followButton.classList.contains(followClass) ? "follow" : "unfollow";
    const shouldFollow = action === "follow";
    const apiCall = shouldFollow ? api.brands.followPage : api.brands.unfollowPage;

    await apiCall({ brand_id: $followButton.dataset.brandId })
      .then(({ data }) => {
        $followLabel.textContent = data.followed ? "Following" : "Follow";
        $followButton.classList.toggle(unFollowClass, shouldFollow);
        $followButton.classList.toggle(followClass, !shouldFollow);
      })
      .catch(() => {
        notifyError("Error while following");
      });
  };

  $followButton.addEventListener("click", followHandler);
};

export default () => {
  initFollow();
  initFollowSignIn();
};
